import React from "react";

const SideSection = ({ imageUrl }) => {
  return (
    <div className="bg-white w-full h-screen shadow-lg overflow-hidden flex flex-col">
      {/* Top Image (only visible on large screens) */}
      <div className="hidden lg:flex h-[70%] 2xl:h-[60%] w-full overflow-hidden">
        <img src={imageUrl} alt="Travel Promo" className="w-full h-full object-cover max-2xl:object-right" />
      </div>

      {/* Bottom Section with Background Decoration */}
      <div className="relative bg-pink-50 h-full lg:h-[30%] 2xl:h-[40%] overflow-hidden px-10 md:px-14 py-10 
                      flex flex-col justify-start xl:justify-center gap-6">

        {/* Background image with opacity */}
        <div
          className="absolute inset-0 bg-no-repeat bg-right-top bg-contain opacity-40 pointer-events-none"
          style={{ backgroundImage: "url('/icons/vector.svg')" }}
        ></div>

        {/* CONTENT (stays above) */}
        <div className="relative space-y-4 max-w-xl">
          <div>
            <img src="/icons/logo-pulo.svg" alt="PULO logo" />
          </div>
          <div className="space-y-4 max-2xl:w-96">
            <h2 className="text-4xl md:text-5xl lg:text-3xl  2xl:text-6xl font-semibold text-[#570033] leading-tight">
              Simplify Your Travel Experience Today.
            </h2>
            <p className="text-[#570033] font-medium text-lg 2xl:text-xl">
              Book rides, find local guides, and secure stays—all in one place, effortlessly.
            </p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default SideSection;
